module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p-checkbox', {
    attrs: {
      "name": _vm._name,
      "disabled": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a8cc9d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-checkbox.vue
// module id = 528
// module chunks = 55